import { IMoreMenuItem } from '@sales-center/components'
import { useDialogState } from '@user/utils/useDialogState'
import { useMemo } from 'react'
import { LeadParentHeaderProps } from '../typings'
import { LeadAttachmentsDrawerState } from './typings'

export function useLeadAttachmentsDrawer(
  params: LeadParentHeaderProps,
): LeadAttachmentsDrawerState {
  const { detailPage } = params

  const [attachmentsOpen, onOpenAttachments, onCloseAttachments] =
    useDialogState()

  const attachmentsMenuItem = useMemo<IMoreMenuItem>(
    () => ({
      label: 'Attachments',
      hidden: detailPage,
      dataTestId: `attachmentsBtn`,
      onClick: onOpenAttachments,
    }),
    [detailPage, onOpenAttachments],
  )

  return {
    attachmentsOpen,
    onOpenAttachments,
    onCloseAttachments,
    attachmentsMenuItem,
  }
}
